<div class="profile-gallery-container public-profile-card" *ngIf="showCard">
    <div class="card-container">
        
        <!-- Card -->
        <mat-card *ngIf="finishLoading">

            <!-- Header -->
            <mat-card-header>
                <mat-icon fontSet="phr-iconset" class="phr-iconset-picture"></mat-icon>
                <span class="header-title">{{ 'publicProfiles.gallery.headerTitle' | translate:locale.language }}</span>            
            </mat-card-header>
            
            <div class="header-separator"></div>

            <!-- Content -->
            <mat-card-content>
                <div class="img-container col s12 m12">
                    <div class="image-item-container">
                        <div class="img-item" *ngFor="let img of getImages(); index as i; trackBy: imageTrackBy">
                            <span class="helper"></span>
                            <img [src]="img.ubicacionFoto" (click)="onFileClick(img)">
                        </div>
                    </div>
                </div>
                <!-- <div class="col s12 m12 show-more-container" *ngIf="showMoreImages">
                    <div *ngIf="showMore" (click)="showMore = !showMore;">
                        <span>{{ 'publicProfiles.gallery.showLess' | translate:locale.language }}</span>
                    </div>
                    <div *ngIf="!showMore" (click)="showMore = !showMore;">
                        <span>{{ 'publicProfiles.gallery.showMore' | translate:locale.language }}</span>
                    </div>
                </div> -->
            </mat-card-content>

        </mat-card>

        <!-- Skeleton -->
        <mat-card class="skeleton-card" *ngIf="!finishLoading">
            <mat-card-header>
                <span class="header-title">
                    <ngx-skeleton-loader [theme]="{ 'width': '190px', 'height': '17px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>         
                </span>
            </mat-card-header>

            <div class="header-separator"></div>

            <mat-card-content>
                <div class="img-container col s12 m12">
                    <div class="image-item-container">
                        <div class="img-item">
                            <span class="helper"></span>
                            <ngx-skeleton-loader [theme]="{ 'width': '150px', 'height': '120px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div>
                        <div class="img-item">
                            <span class="helper"></span>
                            <ngx-skeleton-loader [theme]="{ 'width': '150px', 'height': '120px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div>
                        <div class="img-item">
                            <span class="helper"></span>
                            <ngx-skeleton-loader [theme]="{ 'width': '150px', 'height': '120px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

    </div>    
</div>



